import { render } from "./remote.vue?vue&type=template&id=5c66156c"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__